import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import MenuLateralModulo from "./Vinculo/VinculoContainer";
import Farol from "features/manejo/views/MenuLateral/Farol/FarolContainer";
import PastureRegistrations from "./Registration/FormPasto/pastureRegistrationsContainer";
import CadastroRetiroContainer from "../../../retiro/views/cadastroRetiroContainer";
import Registrations from "./Registration/Registrations";
import NewFarmFormContainer from "./Registration/FormPasto/newFarmFormContainer";
import { PortalRoutes } from "constants/routes";

class SwitchMenuLateral extends Component {
  render() {
    return (
      <Switch>
        <Route exact path={PortalRoutes.STATUS_INDICATOR} component={Farol} />
        <Route
          path={PortalRoutes.MODULE_LINKAGE}
          component={MenuLateralModulo}
        />
        <Route
          exact
          path={PortalRoutes.PASTURE_REGISTRATIONS}
          component={Registrations}
        />
        <Route
          exact
          path={PortalRoutes.EDIT_PASTURE}
          component={PastureRegistrations}
        />
        <Route
          exact
          path={PortalRoutes.NEW_PASTURE}
          component={PastureRegistrations}
        />
        <Route
          exact
          path={PortalRoutes.NEW_FARM}
          component={NewFarmFormContainer}
        />
        <Route
          exact
          path={PortalRoutes.RETREAT_REGISTRATIONS}
          component={CadastroRetiroContainer}
        />
      </Switch>
    );
  }
}

export default SwitchMenuLateral;
